import { useState } from 'react';
import { Roles } from '../../../../../common/src/enums/Roles';
import { useUserHasRole } from './useUserHasRole';

export function useCanUserEditObject() {
    const { userHasRole } = useUserHasRole();

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const [canUserEditObject] = useState(userHasRole([Roles.Administrator, Roles.Client, Roles.Owner]));

    return { canUserEditObject };
}
